import React, { useState } from 'react';
import {makeStyles, CssBaseline, Hidden} from '@material-ui/core';
import { mainTheme } from '../../theme/theme';
import { ThemeProvider } from '@material-ui/styles';
import PetsAppBar from '../../components/Navigation/AppBar/PetsAppBar';
import PetsSideDrawer from '../../components/Navigation/SideDrawer/PetsSideDrawer';

const drawerWidth = 256;

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    minHeight: "100vh",
  },
  drawer: {
    [theme.breakpoints.up("md")]: {
      width: drawerWidth,
      flexShrink: 0
    }
  },
  appContent: {
    flex: 1,
    display: "flex",
    flexDirection: "column"
  },
  mainContent: {
    flex: 1,
    padding: "46px 36px 0"
  }
}));

const Layout = props => {
  const classes = useStyles();
  const [ mobileOpen, setMobileOpen ] = useState(false);

  const drawerToggleHandler = event => {
    setMobileOpen(prev => !prev);
  }

  return (
    <ThemeProvider theme={mainTheme}>
      <div className={classes.root}>
        <CssBaseline />
        {/* <nav className={classes.drawer}> */}
          {/* <Hidden mdUp implementation="js">
            <PetsSideDrawer
              PaperProps={{ style: { width: drawerWidth } }}
              variant="temporary"
              open={mobileOpen}
              onClose={drawerToggleHandler}
            />
          </Hidden>
          <Hidden smDown implementation="css">
            <PetsSideDrawer PaperProps={{ style: { width: drawerWidth } }} />
          </Hidden> */}
        {/* </nav> */}
        <nav className={classes.drawer}>
          <Hidden mdUp implementation="js">
            <PetsSideDrawer
                PaperProps={{ style: { width: drawerWidth } }}
                variant="temporary"
                open={mobileOpen}
                onClose={drawerToggleHandler}
              />
          </Hidden>
          <Hidden smDown implementation="css">
            <PetsSideDrawer PaperProps={{ style: { width: drawerWidth } }} />
          </Hidden>
        </nav>
        <div className={classes.appContent}>
          <PetsAppBar onDrawerToggle={ev => drawerToggleHandler(ev)} />
          {props.children}
        </div>
      </div>
    </ThemeProvider>
  );
};



export default Layout;